const initialState = {
  phases: [],
  sessionId: null,
  currentPhaseIndex: 0,
  currentQuestionIndex: 0,
  answers: {},
  result: null,
  isComplete: false,
  isLoading: false,
  error: null,
};

export default function assessmentReducer(state = initialState, action) {
  switch (action.type) {
    case 'ASSESSMENT_LOAD':
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case 'ASSESSMENT_LOAD_SUCCESS':
      return {
        ...state,
        isLoading: false,
        phases: action.payload?.phases || [],
        sessionId: action.payload?.sessionId || state.sessionId,
      };

    case 'ASSESSMENT_LOAD_FAIL':
      return {
        ...state,
        isLoading: false,
        error: action.payload?.message || 'Failed to load assessment',
      };

    case 'ASSESSMENT_SUBMIT_ANSWER':
      return {
        ...state,
        isLoading: true,
      };

    case 'ASSESSMENT_SUBMIT_ANSWER_SUCCESS':
      return {
        ...state,
        isLoading: false,
        answers: {
          ...state.answers,
          [action.request?.questionId]: action.request?.answer,
        },
      };

    case 'ASSESSMENT_SUBMIT_ANSWER_FAIL':
      return {
        ...state,
        isLoading: false,
        error: action.payload?.message || 'Failed to submit answer',
      };

    case 'ASSESSMENT_GET_RESULT':
      return {
        ...state,
        isLoading: true,
      };

    case 'ASSESSMENT_GET_RESULT_SUCCESS':
      return {
        ...state,
        isLoading: false,
        result: action.payload?.result || action.payload,
        isComplete: true,
      };

    case 'ASSESSMENT_GET_RESULT_FAIL':
      return {
        ...state,
        isLoading: false,
        error: action.payload?.message || 'Failed to get results',
      };

    case 'ASSESSMENT_RESET':
      return {
        ...state,
        isLoading: true,
      };

    case 'ASSESSMENT_RESET_SUCCESS':
      return {
        ...initialState,
      };

    case 'ASSESSMENT_RESET_FAIL':
      return {
        ...state,
        isLoading: false,
        error: action.payload?.message || 'Failed to reset assessment',
      };

    case 'ASSESSMENT_SET_PHASE':
      return {
        ...state,
        currentPhaseIndex: action.payload,
        currentQuestionIndex: 0,
      };

    case 'ASSESSMENT_SET_QUESTION':
      return {
        ...state,
        currentQuestionIndex: action.payload,
      };

    case 'ASSESSMENT_NEXT_QUESTION':
      const currentPhase = state.phases[state.currentPhaseIndex];
      const isLastInPhase = state.currentQuestionIndex >= (currentPhase?.questions?.length || 0) - 1;
      const isLastPhase = state.currentPhaseIndex >= state.phases.length - 1;

      if (isLastInPhase && isLastPhase) {
        return {
          ...state,
          isComplete: true,
        };
      }

      return {
        ...state,
        currentPhaseIndex: isLastInPhase ? state.currentPhaseIndex + 1 : state.currentPhaseIndex,
        currentQuestionIndex: isLastInPhase ? 0 : state.currentQuestionIndex + 1,
      };

    default:
      return state;
  }
}
